import React from 'react'
import { Container, Image, Row, Col } from 'react-bootstrap'
import policies2 from '../../assets/pdfFile/Fund Raiser Final.pdf'

const DonationBottomContant = () => {
    return (
        <>
            <Container>

                <div className='row'>
                    <div className='col-sm-6'>

                        <h3>How can you help us?</h3>
                        <h5>Donate:</h5>
                        <p>You can donate by filling the form above.
                            <br />
                            Or through: <a href='https://causes.benevity/projects/655793' target='_blank'>https://causes.benevity/projects/655793 </a>
                        </p>
                        <h5>Volunteer</h5>
                        <p>You can come and help us on site by documentation photos, videos, sketches or in
                            writing. <br />
                            For queries regarding volunteering, please contact Sourabh at +91-7000084691
                        </p>
                        <h5>Spread the word!</h5>
                        <p>You can share forward about our fund-raising campaign and let more people know
                            about it. Let your socially and environmentally conscious friends and family know
                            that a Mud School needs their help!</p>
                    </div>

                    <div className='col-sm-6'>
                        <Image src={require('../../assets/images/donate/1.png')} className='w-100' />
                    </div>
                </div>


                {/* <Row>
                    <div className='col-sm-6'>
                        <Image src={require('../../assets/images/donate/2.png')} className='w-100' />
                    </div>
                    <div className='col-sm-6'>

                        <div className='page-donate mt-3'>
                            <h2>Mud School Building Restoration Fundraiser</h2>
                            <h5>Help us restore and conserve Muskaan NGO’s earthen school —</h5>
                            <p>for children who need it the most. You can help us rebuild not only safe walls but also
                                spaces of dignity, resilience and hope.</p>
                            <p>Since 1998, Muskaan NGO has been tirelessly ensuring education and child rights
                                access to children of denotified tribes and marginalized communities in and around
                                Bhopal. For our community of educators and students, our mud-building community
                                school, Jeevan Siksha Pahal, isn’t just a cluster of classrooms and hostel rooms- it’s a
                                symbol of belonging and dignity. Today, this mud-building requires urgent repairs to
                                its weathered walls.</p>
                        </div>
                    </div>

                    <div className='col-sm-12'>
                        <div className='page-donate mt-2'>
                            <h3 className='pt-2'>ABOUT THIS BUILDING</h3>
                            <p>Muskaan’s Mud Home is a 2 storey Adobe bricks building, with each floor having
                                6620 SqFt built-up area. It’s one of the biggest contemporary Adobe structures in
                                India designed by Kamath Design Studio.</p>
                            <p>More than passion, this building embodies the ambition that Revathi Kamath had
                                to prove that mud could create architecture that was monumental, modern and
                                rooted. The mud walls are familiar and welcoming to students who come from
                                village homes made of mud and thatch. The spaces are designed to help students
                                open up without hesitation or intimidation of an alienating urban world. At the
                                same time, this building is intended to be a stark model of ecological design, local-
                                traditional construction methods, and environmental protection. Currently it hosts
                                200 students with hostel space for over 50 students.</p>
                            <h5>Have more insight into the building process in <a href="https://www.youtube.com/watch?v=SfT30aIQESs" target='blank'> this video. </a></h5>
                        </div>
                        <div className='row page-donate mt-2'>
                            <div className='col-sm-6'>
                                <Image src={require('../../assets/images/donate/3.png')} className='w-100' />
                            </div>
                            <div className='col-sm-6'>
                                <Image src={require('../../assets/images/donate/4.png')} className='w-100' />
                            </div>
                        </div>
                    </div>
                    <div className='page-donate mt-2'>
                        <Image src={require('../../assets/images/donate/5.png')} className='w-100' />
                        <p>After monsoon showers in September 2024, <b>a bathroom wall collapsed</b>  due to water
                            seepage. These are currently braced by temporary structural supports.</p>

                    </div>

                    <div className='page-donate'>
                        <div className='row'>
                            <div className='col-sm-5'>
                                <Image src={require('../../assets/images/donate/7.png')} className='w-100' />
                            </div>
                            <div className='col-sm-7'>
                                <Image src={require('../../assets/images/donate/8.png')} className='w-100' />
                            </div>
                        </div>
                    </div>


                    <div className='page-donate mt-2'>


                        <div className='row'>
                            <div className='col-sm-5'>
                                <p className='pt-3'>The collapsed wall, connected to our boys’ and girl’s washrooms, has rendered <b>both
                                    the washrooms unusable, </b>leading to <b>hygiene and sanitation concerns.</b> We have
                                    been managing through temporary toilet structures created outside the building. But
                                    this arrangement will not sustain, and the building inside needs repairs.</p>
                            </div>

                            <div className='col-sm-7'>
                                <Image src={require('../../assets/images/donate/9.png')} className='w-100' />
                            </div>
                        </div>




                    </div>
                    <div className='page-donate mt-2'>
                        <h3 className='pt-2'>MOVING AHEAD</h3>
                        <p>We plan on undertaking a restoration process that honours the original materials and
                            intent, while strengthening and conserving it for the future.</p>
                        <p>For restoring and conserving our school, we choose to lean on natural building
                            techniques to repair damaged walls and make structural improvements (adding
                            plinth protection, extending ledges, reinforcing lintels, correcting arches among other
                            details). Reconstructing hygienic and accessible toilets for both girls and boys is a top
                            priority.</p>

                        <div className='row'>
                            <div className='col-sm-7'>
                                <Image src={require('../../assets/images/donate/10.png')} className='w-100' />
                            </div>
                            <div className='col-sm-5'>
                                <Image src={require('../../assets/images/donate/11.png')} className='w-100' />
                            </div>
                        </div>
                    </div>


                    <div className='page-donate mt-2'>
                        <p>Jaali wall had to be taken down because it was exposed to the rain.
                            An alternate Jalli wall will be designed and built.</p>


                        <div className='row'>
                            <div className='col-sm-6'>
                                <Image src={require('../../assets/images/donate/12.png')} className='w-100' />
                            </div>
                            <div className='col-sm-6'>
                                <Image src={require('../../assets/images/donate/13.png')} className='w-100' />
                            </div>
                        </div>

                    </div>


                    <div className='page-donate mt-2'>
                        <p>To repair the wall that fell down during the downpour of 2024,
                            we had to repair the Arched wall beside it. Water damage was
                            eveident in the surrounding walls. We have supported the floor
                            above using jacks and taken down the walls, section by section,
                            delicately repairing one part at a time.</p>

                    <div className='row'>
                        <div className='col-sm-6'>
                            <Image src={require('../../assets/images/donate/14.png')} className='w-100' />
                        </div>
                        <div className='col-sm-6'>
                            <Image src={require('../../assets/images/donate/15.png')} className='w-100' />
                        </div>
                    </div>
                    </div>


                    <div className='page-donate mt-2'>

                        <p>We are working closely with architects and conservation consultants. Also, 3 labourers
                            are required to work on the construction daily, along with 2 masons to construct the
                            outer structures on a regular basis. When we work on supporting the lintels, and
                            centering the arches, the number of labourers will be temporarily increased to 10 to
                            provide additional support.</p>
                        <h6>We are hoping to complete all structural changes before monsoon this year.</h6>
                    </div>

                    <div className='page-donate mt-2'>
                        <Image src={require('../../assets/images/donate/16.png')} className='w-100' />

                        <div className='row'>
                            <div className='col-sm-6'>


                                <h3>How can you help us?</h3>
                                <h4>Donate</h4>
                                <p>The total cost for the restoration is projected at <b>INR 27,61,458</b>. This will include the
                                    repair and reconstruction of the parts of the building that require upgrading, as well
                                    as the electrical and plumbing work to ensure the toilets are in operation as soon as
                                    possible. A detailed estimate of the cost has been included on this link.</p>
                                <p>You can donate through this form. All donations directly impact the organisation and
                                    help us further our mission. For donations related queries contact us at <b>+91-91659 28519</b></p>

                                <h4 className='pt-3'>Volunteer</h4>
                                <p>You can come and help us on site by documenting in photo, video, sketches and
                                    writing. You will learn the process of restoration that we are taking and also about
                                    the different techniques that were used to built the Adobe Mud building.
                                    Volunteering charges are <b>INR 800/day</b>.</p>
                                <p>If you wish to volunteer with us on site, contact us at <b>+91-7000084691.</b></p>

                                <h6>This fundraiser supports Muskaan NGO’s unique earthen school,
                                    providing vital education to marginalized children since 1998.

                                </h6>
                                <h6>       Your contribution will help restore not just safe walls, but a crucial space of
                                    hope, resilience, and opportunity for students who need it most.
                                </h6>
                                <h6>   <br />
                                    You can know more about Muskaan NGO here <a href='www.muskaan.org'>www.muskaan.org</a></h6>
                            </div>
                            <div className='col-sm-6'>
                                <div className='page-donate mt-2'>
                                    <Image src={require('../../assets/images/donate/18.png')} className='w-100' />

                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <a href={policies2} target="_blank" className='btn main-bg text-white py-3 px-5 border-none border-0 w-100  btn btn-primary'> Download PDF </a>

                            </div>
                        </div>

                    </div>




                </Row> */}
            </Container>
        </>
    )
}
export default DonationBottomContant
